export default __webpack_public_path__ + "static/media/employee.f9f41a75.png";